import { GROUPS } from '@/service/apiConf';

/** 运营中心子中心：产品 / 计费 / 资源与交付 / 策略分组菜单 */
export function getBizCenterOperationGroups(biz: string) {
  return [
    {
      title: 'productManagement',
      icon: 'icon-a-chanpinguanli1',
      children: [
        // 产品类别 / 产品列表已迁至系统管理-运营中心-产品管理
        {
          title: 'productSku',
          path: `${biz}/products/skus`,
          icon: 'icon-icon_chanpinguige_huitai_tab',
          viewAuth: [GROUPS.ophub, 'skus', 'list'],
        },
        {
          title: 'productSku',
          path: `${biz}/products/skus/custom`,
          hidden: true,
        },
      ],
    },
    {
      title: 'billManagement',
      icon: 'icon-jifeiguanli',
      children: [
        {
          title: 'billModels',
          path: `${biz}/bill-models`,
          icon: 'icon-jifeimoxing',
          viewAuth: [GROUPS.ophub, 'bill-models', 'list'],
        },
        {
          title: 'billItems',
          path: `${biz}/bill-items`,
          icon: 'icon-daibaojia',
          viewAuth: [GROUPS.ophub, 'bill-items', 'list'],
        },
      ],
    },
    {
      title: 'resourcesAndDelivery',
      icon: 'icon-a-ziyuan117',
      children: [
        {
          title: 'atomResources',
          path: `${biz}/atom-resources`,
          icon: 'icon-a-ziyuan117',
          viewAuth: [GROUPS.ophub, 'resources', 'list'],
        },
        {
          title: 'deployTypes',
          path: `${biz}/deploy-types`,
          icon: 'icon-bushu1',
          viewAuth: [GROUPS.ophub, 'deployment-types', 'list'],
        },
      ],
    },
    {
      title: 'tagManagement',
      icon: 'icon-biaoqianguanli',
      children: [
        {
          title: 'tags',
          path: `${biz}/tags`,
          icon: 'icon-biaoqianguanli',
          viewAuth: [GROUPS.ophub, 'label-definitions', 'list'],
        },
        {
          title: 'couponStrategy',
          path: `${biz}/coupon-strategy`,
          icon: 'icon-youhuijuan',
          viewAuth: [GROUPS.ophub, 'coupons', 'list'],
        },
      ],
    },
  ];
}

/** 运营中心子中心完整菜单（含概览与费用中心） */
export function getBizCenterMenuChildren(biz: string) {
  return [
    {
      title: 'consoleOverview',
      icon: 'icon-gailan',
      path: `${biz}/charges`,
      viewAuth: [GROUPS.ophub, 'revenue-analysis', 'get'],
    },
    ...getBizCenterOperationGroups(biz),
    {
      title: 'chargeCenter',
      icon: 'icon-jifeiguanli',
      children: [
        {
          title: 'orderManagement',
          icon: 'icon-dingdanguanli',
          path: `${biz}/orders`,
          viewAuth: [GROUPS.ophub, 'order-items', 'list'],
        },
        {
          title: 'billManagement1',
          icon: 'icon-jifeiguanli',
          path: `${biz}/bills`,
          viewAuth: [GROUPS.ophub, 'invoices', 'list'],
        },
      ],
    },
  ];
}
